import React from 'react';
import PropTypes from 'prop-types';
import {MarkerCreateFuncs, OverlappingMarkerCreateFuncs} from '../../MapComponents';
import {IconService, notPlanedIconColor} from '../../../../services/icon/iconService';
import BaseTourMap from '../../BaseMaps/BaseTourMap';
import {filterTemplateStopInstanceToursForCoords} from '../../../../services/util/mapUtils';

const TemplateStopTourMap = React.memo(props => {

  const {
    className,
    toursWithStops,
    notPlanedStops,
    displayStopType,
    displayNotPlanedStops,
    setSelectedStop,
    noControls
  } = props;

  return (
    <BaseTourMap
      className={className}
      displayControls={!noControls}
      displayMicroHubs={false}
      displayStops={displayNotPlanedStops}
      getOverLappingMarkerClusterIcon={(overlappingElements, highLiteDuplicates) => displayStopType
        ? OverlappingMarkerCreateFuncs.getForTourWithStopTypeMap(overlappingElements, highLiteDuplicates)
        : OverlappingMarkerCreateFuncs.getForTourMap(overlappingElements, highLiteDuplicates)}
      getStopClusterIcon={() => IconService.getMarkerClusterIcon(notPlanedIconColor)}
      getStopMarkerAndAddToMcg={(stop, mcg, t) => MarkerCreateFuncs.getTemplateStopServiceInstanceMarker(stop, mcg, t, setSelectedStop, notPlanedIconColor)}
      getTourClusterIcon={(tour) => IconService.getMarkerClusterIcon(tour.color, tour.id)}
      getTourStopMarkerAndAddToMcg={(tour, stop, mcg, t) => MarkerCreateFuncs.getTemplateStopInstanceTourStopMarker(tour, stop, mcg, t, setSelectedStop, displayStopType)}
      microHubs={[]}
      stops={notPlanedStops}
      tours={toursWithStops}
      filterToursForCoords={filterTemplateStopInstanceToursForCoords}
    />
  );
});

TemplateStopTourMap.displayName = 'TemplateStopTourMapComponent';

TemplateStopTourMap.propTypes = {
  className: PropTypes.string,
  displayNotPlanedStops: PropTypes.bool,
  displayStopType: PropTypes.bool,
  noControls: PropTypes.bool,
  notPlanedStops: PropTypes.array,
  setSelectedStop: PropTypes.func,
  toursWithStops: PropTypes.array,
};

export default TemplateStopTourMap;

